import React from 'react';

import {useTranslation} from "react-i18next";

import UserTable from "../../components/table/user-table";
 import CustomLink from "../../components/UI/customLink/customLink";
import {useNavigate} from "react-router-dom";
import {PlusIcon} from "../../icons/icons";

const UserSection = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const handleEdite = (e) => {
    navigate(`/basic-information/user/new/${e.id}`);
  }

  return (
    <div className={"flex flex-col w-full pb-32"}>
      <div className={"my-container rounded-lg  flex justify-end items-center w-full"}>
        <div className={"w-[207px]"}>
          <CustomLink icon={<PlusIcon/>} link={"/basic-information/user/new"} title={t("newUser")}/>
        </div>
      </div>
      <div>
        <UserTable editItem={(e) => handleEdite(e)}/>
      </div>
    </div>
  );
};

export default UserSection;
